<template>

    <v-page-body>
        <v-section-options />
        <v-section-theme />
        <v-section-tracking-domain />
    </v-page-body>

</template>

<script>

import ProjectApi from '@api/ProjectApi';
import SectionOptions from './components/SectionOptions';
import SectionTheme from './components/SectionTheme';
import SectionTrackingDomain from './components/SectionTrackingDomain';

export default {

    components: {
        'v-section-options': SectionOptions,
        'v-section-theme': SectionTheme,
        'v-section-tracking-domain': SectionTrackingDomain,
    },

    mounted() {
        this.getProject();
    },

    methods: {

        getProject() {
            this.$store.commit('loading', true);
            ProjectApi.getProject(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

    },

}

</script>